import { gql } from '@apollo/client';

import { academyProfessorFragment } from '../fragments';
import { AcademyProfessor } from '../../types';

export interface GetAcademyProfessorsQueryResult {
  academyProfessors: AcademyProfessor[];
}

export const getAcademyProfessorsQuery = gql`
  query GetAcademyProfessorsQuery {
    academyProfessors @rest(type: "AcademyProfessor", path: "academy/professors") {
      ...AcademyProfessor
    }
  }
  ${academyProfessorFragment}
`;
